import { createReducer } from '@reduxjs/toolkit';
import { IUserState } from './types';
import { fetchUserProfile, fetchUserPermissions } from './actions';
import { logout } from '../login/reducers/index';

const initialState: IUserState = {
  profile: {
    loading: false,
    data: null,
    error: null,
  },
  permissions: {
    loading: false,
    isLoaded: false,
    data: {},
    error: null,
  },
};

export const userProfileReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchUserProfile.pending, (state) => {
      state.profile.loading = true;
      state.profile.error = null;
    })
    .addCase(fetchUserProfile.fulfilled, (state, action) => {
      state.profile.loading = false;
      state.profile.data = action.payload.data; // Assign the Profile data from the payload
    })
    .addCase(fetchUserProfile.rejected, (state, action) => {
      state.profile.loading = false;
      state.profile.error = action.payload as string;
    })
    .addCase(fetchUserPermissions.pending, (state) => {
      state.permissions.loading = true;
      state.permissions.error = null;
    })
    .addCase(fetchUserPermissions.fulfilled, (state, action) => {
      state.permissions.loading = false;
      state.permissions.isLoaded = true;
      state.permissions.data = action.payload?.data?.modules || {};
    })
    .addCase(fetchUserPermissions.rejected, (state, action) => {
      state.permissions.loading = false;
      state.permissions.isLoaded = true;
      state.permissions.error = action.payload as string;
    })
    .addCase(logout, (state) => { // Handle logout action
      state.profile.data = null;
      state.permissions.data = {};
      state.permissions.isLoaded = false;
    });
});